module.exports = __webpack_public_path__ + "img/alcoholvrije-chocoladetiramisu.ae765b88.jpeg";